import React from 'react';
import styled from 'styled-components';
import {CONSTS}  from './_constants';
import Icon from './icon';

const Input = (props) => (
    <div className={props.className}>
        {props.icon && <Icon className="_icon" icon={props.icon} />}
        <input {...props} className=""  />
    </div>
)

const StyledInput = styled(Input)`
    position: relative;
    > ._icon{
        position: absolute;
        left: 15px;
        top: 50%;
        transform: translateY(-50%);
        color: ${CONSTS.colors.primary};
        font-size: 14px;
    }
    > input{
        padding: 15px 25px;
        ${props => props.icon && `padding-left: 45px;`}
        border: 1px solid rgba(100, 100, 100, .2);
        color: #666;
        border-radius: ${CONSTS.border.radius};
        text-align: left;
        font-size: 15px;
        box-sizing: border-box;
        margin-top:5px;
        margin-bottom:5px;
        ${ props =>(
            props.inline ? "" : `
                width: 100%;
            `
        )
        }

        :focus{
            outline: none;
            border-color: rgba(100, 100, 100, .4);
            color: #333;
        }
        ::placeholder{
            color:#999;
        }
    }
    
`;

export default StyledInput;